import { render, staticRenderFns } from "./studentRegisterLayout.vue?vue&type=template&id=fd7b05e4&scoped=true&"
import script from "./studentRegisterLayout.vue?vue&type=script&lang=js&"
export * from "./studentRegisterLayout.vue?vue&type=script&lang=js&"
import style0 from "./studentRegisterLayout.vue?vue&type=style&index=0&id=fd7b05e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7b05e4",
  null
  
)

export default component.exports